/**
 * Global Not Found Page
 * Shown when navigating to an unknown route
 */

import { Link } from '@tanstack/react-router';
import { EmptyState } from '@/components/ui';

export function NotFoundView() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <EmptyState
          title="Page not found"
          description="The page you're looking for doesn't exist or has been moved."
          icon={
            <svg
              className="mx-auto h-16 w-16 text-muted"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1}
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          }
        />
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/settings" className="btn-primary">
            Go to Settings
          </Link>
        </div>
      </div>
    </div>
  );
}
